
import React from 'react'
import numeral from 'numeral'

import SPACE from '../config/spaces'
import { usePopover } from '../helpers/Popover'


export default function Port({ 
	port,
	nocount = false,
	// nopopover = false,
}) {

	// const { popoverHandlers } = !nopopover
	// 	?	usePopover({ 
	// 			url: port.slug, 
	// 			attrs: port.attrs ?? null 
	// 		})
	// 	:	{ popoverHandlers: {} }

	return <span className='port'
		// data-popover={port.slug}
		// {...popoverHandlers}
	>

		{ (!nocount && port.count > 1) &&
			<span className='pCount'>
				{`${port.count || 1}${SPACE.xs}×`}
			</span>
		}		

		<span className='pName'>
			{ port.attrs?.type
				? `${port.name} ${port.attrs.type}`
				: `${port.name}`
			}
		</span>
		
		{ (port.name !== 'USB-C' && port.attrs?.version > 0) && <>
			{SPACE.nb}
			<span className='pVer'>
				{ numeral(port.attrs.version).format('0.0') }
			</span>
		</>}

		{/* { port.attrs?.hdcp > 0 && <>
			{SPACE.nb}
			<small className='pHDCP'>
				HDCP
			</small>
		</>} */}

		{ port.attrs?.mhl > 0 && <>
			{SPACE.nb}
			<small className='pMHL'>
				MHL
			</small>
		</>}

		{ !!port.attrs?.dp && <>
			{SPACE.nb}
			<small className='pDP'>
				+ DisplayPort
			</small>
		</>}

		{ !!port.attrs?.out && <>
			{SPACE.nb}
			<span className='pOut'>out</span> 
		</> }

	</span>
}